<template>
    <modal @close="closeFromModal">
        <h5 slot="header">{{ title }} un produit</h5>
        <div slot="body">
            <add-gift-voucher-product ref="addGiftVoucherProduct" :product="product" @saved="$emit('saved')" @saving="saving = $event" />
        </div>
        <div slot="footer" class="d-flex">
            <button type="button" class="modal-default-button btn btn-sm btn-secondary btn-circle" @click="$emit('close')">Annuler</button>
            <button
                type="button"
                class="btn btn-sm btn-success btn-circle ms-2"
                :disabled="saving"
                :aria-busy="saving"
                @click="$refs.addGiftVoucherProduct.save()">
                {{ saving ? "Enregistrement…" : "Enregistrer" }}
            </button>
        </div>
    </modal>
</template>

<script>
import addGiftVoucherProduct from "../../giftVouchers/addGiftVoucherProduct";

export default {
    data() {
        return {
            saving: false,
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            e.stopPropagation();
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    props: {
        product: {
            type: Object,
            required: true,
        },
        duplicate: {
            default: false,
        },
    },
    computed: {
        title() {
            if (this.duplicate) return "Dupliquer";
            if (this.product.id !== null) return "Modifier";
            return "Ajouter";
        },
    },
    components: {
        addGiftVoucherProduct,
    },
};
</script>
